import { QueryClient } from "@tanstack/react-query";

/**
 * The application's query cache, created outside the React tree.
 *
 * Writes to customer and project data happen in sagas, and a saga has no way to reach the
 * QueryClientProvider. Without this module the only place to invalidate after a write was the
 * component that dispatched the action - which invalidates before the request has finished and
 * only knows about the caches that one screen uses.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 1000,
            retry: 1,
        },
    },
});
